import {
    ENTRY_COMMENT_LIST_REQUESTED,
    ENTRY_COMMENT_LIST_UPDATE_REQUESTED,
    ENTRY_COMMENT_LIST_RECEIVED,
    ENTRY_COMMENT_LIST_UNMOUNT,
    ENTRY_COMMENT_LIST_ERROR
} from '../actions/entryComments';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|EntryIdAction|ReceiveEntryAction|ReceiveEntryErrorAction} action
 * @return {RequestResult}
 */
export const entryCommentList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case ENTRY_COMMENT_LIST_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), null);
        case ENTRY_COMMENT_LIST_UNMOUNT:
            return new RequestResult(RequestState.getInstanceInit(), null);
        case ENTRY_COMMENT_LIST_UPDATE_REQUESTED:
            return new RequestResult(RequestState.getInstanceUpdating(), state.data);
        case ENTRY_COMMENT_LIST_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.entryCommentList, action.receivedAt);
        case ENTRY_COMMENT_LIST_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
